import { jsx as _jsx } from "react/jsx-runtime";
import MonitoringContext from "./MonitoringContext";
import React from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsErrorBoundary, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory();
export const MonitoringContextProvider = (props) => {
    let reactPlugin = new ReactPlugin();
    // *** Add the Click Analytics plug-in. ***
    /* var clickPluginInstance = new ClickAnalyticsPlugin();
       var clickPluginConfig = {
         autoCapture: true
    }; */
    try {
        let appInsights = new ApplicationInsights({
            config: {
                connectionString: process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION_STRING,
                // *** If you're adding the Click Analytics plug-in, delete the next line. ***
                extensions: [reactPlugin],
                // *** Add the Click Analytics plug-in. ***
                // extensions: [reactPlugin, clickPluginInstance],
                extensionConfig: {
                    [reactPlugin.identifier]: { history: browserHistory }
                    // *** Add the Click Analytics plug-in. ***
                    // [clickPluginInstance.identifier]: clickPluginConfig
                }
            }
        });
        appInsights.loadAppInsights();
        console.log("Application Insights initialized successfully");
    }
    catch (e) {
        console.error("Error initializing Application Insights", e);
    }
    const contextValue = {
        trackEvent: function (name, properties) {
            console.log("MonitoringContextProvider:", properties);
            reactPlugin.trackEvent({ name: name }, properties);
        }
    };
    return _jsx(AppInsightsErrorBoundary, Object.assign({ onError: () => _jsx("h1", { children: "I believe something went wrong" }), appInsights: reactPlugin }, { children: _jsx(MonitoringContext.Provider, Object.assign({ value: contextValue }, { children: props.children })) }));
};
export const useMonitoringContext = () => {
    const context = React.useContext(MonitoringContext);
    if (!context) {
        throw new Error("useMonitoringContext must be used within a MonitoringContextProvider");
    }
    return context;
};
